import Api from "./Api";
import Csrf from "./Csrf";

export default {
  async index() {
    await Csrf.getCookie();

    return Api.get("/bookings");
  },

  async deleted() {
    await Csrf.getCookie();

    return Api.get("/bookings/deleted");
  },

  async cancel(hashed_id) {
    await Csrf.getCookie();

    return Api.get("/bookings/cancel/" + hashed_id);
  },

  async restore(id) {
    await Csrf.getCookie();

    return Api.get("/bookings/restore/" + id);
  },

  async sendVoucher(id) {
    await Csrf.getCookie();

    return Api.get("/bookings/send-voucher/" + id);
  },

  async store(data) {
    await Csrf.getCookie();

    return Api.post("/bookings", data);
  },

  async getRooms(data) {
    await Csrf.getCookie();

    return Api.post("/bookings/guesthouse_rooms", data);
  },

  async actual(date, guesthouse_id) {
    await Csrf.getCookie();
    if (guesthouse_id) {
      return Api.get("/bookings/actual/" + date + "/" + guesthouse_id);
    } else if (date) {
      return Api.get("/bookings/actual/" + date);
    } else {
      return Api.get("/bookings/actual");
    }
  },

  async actualFront(data) {
    await Csrf.getCookie();

    return Api.post("/bookings/actual-front", data);
  },

  async actualFrontAll(data) {
    await Csrf.getCookie();

    return Api.post("/bookings/actual-front-all", data);
  },

  async show(id) {
    await Csrf.getCookie();

    return Api.get("/bookings/" + id);
  },

  async durationUpdated(field, id, data) {
    await Csrf.getCookie();

    return Api.post("/duration_update/" + field + "/" + id, data);
  },
  async updateBookingStartDate(id, data) {
    await Csrf.getCookie();

    return Api.post("/shift-booking-date/" + id, data);
  },

  async priceUpdate(id, manual_price) {
    await Csrf.getCookie();

    return Api.post("/price_update/" + id, { manual_price: manual_price });
  },

  async update(id, object) {
    await Csrf.getCookie();

    return Api.patch("/update/" + id, object);
  },

  async cancelledBookings() {
    await Csrf.getCookie();

    return Api.get("/bookings/cancelled_bookings");
  },

  async unpaidBookings() {
    await Csrf.getCookie();

    return Api.get("/bookings/unpaid_bookings");
  },

  async refundedBooking(id) {
    await Csrf.getCookie();

    return Api.get("/bookings/refunded_booking/" + id);
  },

  async transferBooking(id) {
    await Csrf.getCookie();

    return Api.get("/bookings/transfer_booking/" + id);
  },

  async validateCoupon(data) {
    await Csrf.getCookie();

    return Api.post("/coupon_validate", data);
  },

  async addRoom(id, data) {
    await Csrf.getCookie();

    return Api.post("/add_room/" + id, data);
  },

  async deleteRoom(id, data) {
    await Csrf.getCookie();

    return Api.post("/room_delete/" + id, data);
  },

  async deleteGuest(id, data) {
    await Csrf.getCookie();

    return Api.post("/guest_delete/" + id, data);
  },

  async updateGuest(id, data) {
    await Csrf.getCookie();

    return Api.post("/guest_update/" + id, data);
  },

  async addGuest(id, data) {
    await Csrf.getCookie();

    return Api.post("/add_guest/" + id, data);
  },

  async isDirtyUnset(id) {
    await Csrf.getCookie();

    return Api.get("/is_dirty_unset/" + id);
  },

  async excel() {
    await Csrf.getCookie();

    return Api.get("/csv_bookings", { responseType: "blob" });
  },
};
